import { useEffect, useState } from 'react';
import api from '../services/api';

export default function useJobs(queryString = {}) {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    const getJobList = async () => {
      try {
        setLoading(true);
        const jobList = await api.get(`/jobs?${queryString}&_sort=date:DESC`);
        setJobs(jobList);
      } catch (err) {
        setError(true);
        setJobs([]);
      } finally {
        setLoading(false);
      }
    };

    getJobList();
  }, [queryString]);

  return { jobs, loading, error };
}
